import React from 'react';
import Note from '../assets/images/Note.svg';

export default () => {
  return <img src={Note} alt="" />;
};
